/**
 * クロス設定登録画面 クロス設定登録(リクエストパラメータ)用クラス
 *
 * @export CrossGoodsRegist
 * @class CrossGoodsRegist
 */
export class CrossGoodsRegist {
  /** 受注コード */
  public orderCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** クロス商品 */
  public crossGoods: { PCode: String, ChildKomaSettings: number, PublishSeq: number, FormDispFlag: number }[] = [];
}